import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  REACT_APP_GLOBAL_API_BASE_URL,
  REACT_APP_GLOBAL_API_BASE_URL_V2,
} from 'runtimeEnvVars';

import { addMessageAction } from 'containers/FlashMessage/actions';
import { apiGet, apiPost } from 'utils/axios';

import {
  deliverEmailErrorAction,
  deliverEmailSuccessAction,
  fetchMembersErrorAction,
  fetchMembersSuccessAction,
} from './actions';
import { DELIVER_EMAIL_INIT, FETCH_MEMBERS_INIT } from './constants';

export function* deliverEmail(action) {
  const { messages } = action;
  const url = `${REACT_APP_GLOBAL_API_BASE_URL_V2}/message_templates/deliver`;
  try {
    const response = yield call(apiPost, url, action.params);
    if (action.params.delivery_params.send_at) {
      yield put(addMessageAction(messages.scheduled, 'success'));
    } else {
      yield put(addMessageAction(messages.success, 'success'));
    }
    yield put(deliverEmailSuccessAction(response.data));
  } catch (err) {
    yield put(addMessageAction(messages.error, 'error'));
    yield put(deliverEmailErrorAction(err));
  }
}

export function* fetchMembers(action) {
  const url = `${REACT_APP_GLOBAL_API_BASE_URL}/brands/${action.brandSlug}/users`;

  try {
    const { data: response } = yield call(apiGet, url);
    yield put(fetchMembersSuccessAction(response.users));
  } catch (err) {
    yield put(fetchMembersErrorAction(err));
  }
}

export const deliverEmailSaga = takeLatest(DELIVER_EMAIL_INIT, deliverEmail);
export const fetchMembersSaga = takeLatest(FETCH_MEMBERS_INIT, fetchMembers);

export default function* sendEmailPopupSaga() {
  yield all([deliverEmailSaga, fetchMembersSaga]);
}
